module.exports = __webpack_public_path__ + "img/neos.8d99f613.svg";